import React from 'react';
import { Check, ArrowUpRight } from 'lucide-react';
import { expertise, portfolioHighlights } from '../data/mock';

const PortfolioSection = () => {
  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-0.5 bg-burgundy" />
            <span className="text-burgundy text-sm tracking-widest uppercase font-medium">
              Our Track Record
            </span>
            <div className="w-12 h-0.5 bg-burgundy" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-6">
            Portfolio Highlights
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Expertise List */}
          <div>
            <h3 className="text-2xl font-bold text-charcoal mb-8">
              Our Expertise at a Glance
            </h3>
            <p className="text-slate text-lg mb-8 leading-relaxed">
              Nora Gold Advisory brings integrated, end-to-end advisory support
              across multiple domains:
            </p>
            <ul className="space-y-4">
              {expertise.map((item, index) => (
                <li
                  key={index}
                  className="flex items-start gap-4 group"
                >
                  <div className="w-6 h-6 bg-burgundy/10 flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-burgundy transition-colors duration-300">
                    <Check
                      className="text-burgundy group-hover:text-ivory transition-colors duration-300"
                      size={14}
                    />
                  </div>
                  <span className="text-charcoal font-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Portfolio Stats */}
          <div className="space-y-6">
            {portfolioHighlights.map((highlight) => (
              <div
                key={highlight.id}
                className="group p-6 bg-white border border-slate/10 hover:border-burgundy/30 transition-all duration-500 hover:shadow-lg"
              >
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <span className="text-4xl font-bold text-burgundy">
                      {highlight.stat}
                    </span>
                  </div>
                  <div className="flex-1">
                    <p className="text-slate leading-relaxed">
                      {highlight.description}
                    </p>
                  </div>
                  <ArrowUpRight
                    className="text-gold opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex-shrink-0"
                    size={24}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
